/**
 * Tiny helpers for working with the `unknown` value caught by a
 * `catch` clause. Prefer these over re-typing `catch (e: any)` —
 * `any` silently hides shape mismatches, while `unknown` forces a
 * narrowing step at every call site.
 */

/** Best-effort string extraction from a thrown value. */
export function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object' && 'message' in err) {
    const msg = (err as { message: unknown }).message;
    if (typeof msg === 'string') return msg;
  }
  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
}

/** Type guard used by handlers that want to access `err.code` etc. */
export function isErrorWithCode(
  err: unknown,
): err is Error & { code: string } {
  return (
    err instanceof Error &&
    'code' in err &&
    typeof (err as { code: unknown }).code === 'string'
  );
}
